import { createSlice } from "@reduxjs/toolkit";

export const SearchKeys = createSlice({
  name: "searchKeys",
  initialState: {
    searchKeys: {
      workerReviewsByUsername: "",
      // company searchKeys
      companyClientsUsername: "",
      companyWorkerUsername: "",
      companyWorkername: "All",
      companyAppointmentStatus: "All",

      //Worker Search keys
      workerAppointmentStatus: "All",

      // For Suppliers

      // For Products
      supplierProductSearchValue: "",
      supplierProductCategoryId: "All",
      supplierProductSubCategoryId: "All",
      supplierProductSubSubCategoryId: "All",

      // For Packages
      supplierPackageSearchValue: "",
      supplierPackageCategoryId: "All",
      supplierPackageSubCategoryId: "All",
      supplierPackageSubSubCategoryId: "All",

      // For Inventory Movements
      inventoryMovementSearchValue: "",
      inventoryMovementType: "All",
      inventoryMovementStartDate: "",
      inventoryMovementEndDate: "",


    },
  },
  reducers: {
    setSearchKeys: (state, action) => {
      state.searchKeys = action.payload;
    },
    setSupplierProductSearchValue: (state, action) => {
      state.searchKeys.supplierProductSearchValue = action.payload;
    },
    setSupplierProductCategoryId: (state, action) => {
      state.searchKeys.supplierProductCategoryId = action.payload;
    },
    setSupplierProductSubCategoryId: (state, action) => {
      state.searchKeys.supplierProductSubCategoryId = action.payload;
    },
    setSupplierProductSubSubCategoryId: (state, action) => {
      state.searchKeys.supplierProductSubSubCategoryId = action.payload;
    },

    // For Packages
    setSupplierPackageSearchValue: (state, action) => {
      state.searchKeys.supplierPackageSearchValue = action.payload;
    },
    setSupplierPackageCategoryId: (state, action) => {
      state.searchKeys.supplierPackageCategoryId = action.payload;
    },
    setSupplierPackageSubCategoryId: (state, action) => {
      state.searchKeys.supplierPackageSubCategoryId = action.payload;
    },
    setSupplierPackageSubSubCategoryId: (state, action) => {
      state.searchKeys.supplierPackageSubSubCategoryId = action.payload;
    },

    // For Inventory Movements

    setInventoryMovementSearchValue: (state, action) => {
      state.searchKeys.inventoryMovementSearchValue = action.payload;
    },
    setInventoryMovementType: (state, action) => {
      state.searchKeys.inventoryMovementType = action.payload;
    },
    setInventoryMovementStartDate: (state, action) => {
      state.searchKeys.inventoryMovementStartDate = action.payload;
    },
    setInventoryMovementEndDate: (state, action) => {
      state.searchKeys.inventoryMovementEndDate = action.payload;
    },
  },
});

export const {
  setSearchKeys,
  setSupplierProductSearchValue,
  setSupplierProductCategoryId,
  setSupplierProductSubCategoryId,
  setSupplierProductSubSubCategoryId,
  setSupplierPackageSearchValue,
  setSupplierPackageCategoryId,
  setSupplierPackageSubCategoryId,
  setSupplierPackageSubSubCategoryId,
  setInventoryMovementSearchValue,
  setInventoryMovementType,
  setInventoryMovementStartDate,
  setInventoryMovementEndDate
} = SearchKeys.actions;

export default SearchKeys.reducer;
